export const home = [
    {
        id: "content-frontpage-breaking-news",
        name: "Breaking News",
        articles: [
            {
                id: "8a6ed5ec-89f3-42ad-b948-189d36f278c9",
                class: "columns-3-narrow",
                header: "Uncensored",
                url: "#",
                image: {
                    src: "assets/images/isai-ramos-Sp70YIWtuM8-unsplash_336.jpg",
                    alt: "Placeholder",
                    width: "336",
                    height: "189",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nisl nunc mi ipsum faucibus vitae aliquet.",
                type: "text",
                content:
                    "Velit dignissim sodales ut eu. Sed tempus urna et pharetra. Porttitor rhoncus dolor purus non. Elementum curabitur vitae nunc sed velit dignissim sodales.\n\nPretium fusce id velit ut tortor pretium viverra suspendisse potenti. In nulla posuere sollicitudin aliquam ultrices sagittis orci. Aliquam sem fringilla ut morbi tincidunt augue interdum velit. Nisl nunc mi ipsum faucibus vitae aliquet nec ullamcorper. Nunc mi ipsum faucibus vitae aliquet.",
            },
            {
                id: "d204d10c-879e-4991-802c-25020077e0de",
                class: "columns-3-wide",
                header: "More top stories",
                url: "#",
                image: {
                    src: "assets/images/nasa-dCgbRAQmTQA-unsplash_684.jpg",
                    alt: "Placeholder",
                    width: "684",
                    height: "385",
                },
                meta: {
                    captions: "Photo taken by someone.",
                    tag: {
                        type: "breaking",
                        label: "breaking",
                    },
                },
                title: "Justo eget magna fermentum iaculis eu non diam phasellus vestibulum.",
                type: "text",
                content:
                    "Pulvinar etiam non quam lacus suspendisse faucibus interdum posuere. Arcu bibendum at varius vel pharetra vel turpis nunc. Eget dolor morbi non arcu risus quis varius. Ac odio tempor orci dapibus ultrices in.\n\nAmet tellus cras adipiscing enim eu turpis. Tortor pretium viverra suspendisse potenti nullam. Condimentum vitae sapien pellentesque habitant morbi. Ultrices in iaculis nunc sed augue lacus viverra vitae.",
            },
            {
                id: "e02d07e1-32e3-4ad1-b57c-b945f89d12d3",
                class: "columns-3-narrow",
                header: "Crime & justice",
                url: "#",
                video: {
                    id: "1992-153555258",
                    src: "assets/videos/1992-153555258_tiny.mp4",
                    width: "640",
                    height: "360",
                    type: "HTML5 Video",
                    origin: "https://pixabay.com/videos/world-globe-international-global-1992/"
                },
                meta: {
                    captions: "Video by someone.",
                },
                title: "Eu sem integer vitae justo eget magna fermentum iaculis.",
                type: "text",
                content:
                    "Volutpat commodo sed egestas egestas. Eget lorem dolor sed viverra ipsum nunc aliquet bibendum enim. Felis eget velit aliquet sagittis id consectetur purus. Lorem ipsum dolor sit amet. Ut diam quam nulla porttitor. Id volutpat lacus laoreet non.\n\n Odio morbi quis commodo odio aenean sed adipiscing diam donec. Quis eleifend quam adipiscing vitae proin sagittis nisl. Praesent semper feugiat nibh sed pulvinar proin gravida hendrerit lectus.",
            },
        ],
    },
    {
        id: "content-frontpage-latest-news",
        name: "Latest News",
        articles: [
            {
                id: "7af9e63d-d803-477b-ba8f-539f5d7ed1fe",
                class: "columns-3-balanced",
                header: "Happening Now",
                type: "articles-list",
                content: [
                    {
                        id: "45114281-a2ad-4ed8-bb47-80526e802eb1",
                        title: "Lorem ipsum dolor sit amet.",
                        content:
                            "Molestie nunc non blandit massa enim nec. Ornare suspendisse sed nisi lacus sed viverra tellus in. Id consectetur purus ut faucibus. At auctor urna nunc id cursus metus. Eget aliquet nibh praesent tristique magna. Morbi tristique senectus et netus et malesuada fames.",
                    },
                    {
                        id: "ee8b2a9f-a08b-495e-a4ba-21b3b42bf07d",
                        title: "Consectetur adipiscing elit.",
                        content:
                            "Sit amet consectetur adipiscing elit ut aliquam purus sit. Consequat nisl vel pretium lectus quam. Sagittis id consectetur purus ut faucibus pulvinar elementum integer enim. Nec sagittis aliquam malesuada bibendum arcu.",
                    },
                    {
                        id: "4a9d6914-983d-48ab-a7ed-d7ed1d877a6b",
                        title: "Sed do eiusmod tempor incididunt.",
                        content: "Pulvinar neque laoreet suspendisse interdum consectetur libero id faucibus nisl. Pulvinar elementum integer enim neque volutpat ac. Lorem donec massa sapien faucibus.",
                    },
                ],
            },
            {
                id: "cb7942ac-5ac8-40d1-90fd-7853a0a10d16",
                class: "columns-3-balanced",
                header: "Noteworthy",
                image: {
                    src: "assets/images/peter-lawrence-rXZa4ufjoGw-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Augue neque gravida in fermentum et sollicitudin ac orci.",
                type: "list",
                content: [
                    {
                        id: "b5f94d51-7e7c-4e1f-b55d-e99ba9e2398d",
                        content: "Odio morbi quis commodo odio aenean sed adipiscing diam donec.",
                    },
                    {
                        id: "6ce7f58f-429c-4835-a7fc-8f8bd1f3a12e",
                        content: "Consequat semper viverra nam libero justo laoreet sit.",
                    },
                    {
                        id: "021f9b0b-1666-4d15-a32b-42a464475cc0",
                        content: "Risus ultricies tristique nulla aliquet enim tortor at auctor.",
                    },
                    {
                        id: "bf40e93f-eea6-4f0a-8ad5-1e25cd3b69ab",
                        content: "Diam vulputate ut pharetra sit amet aliquam id diam maecenas.",
                    },
                ],
            },
            {
                id: "cd53f511-0251-4fb0-ae85-9ad228551dd6",
                class: "columns-3-balanced",
                header: "Around the Globe",
                image: {
                    src: "assets/images/rufinochka-XonjCOZZN_w-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Nunc felis tellus, ultrices eget massa ac, lobortis laoreet lorem.",
                type: "list",
                content: [
                    {
                        id: "7e405fe8-7abd-43b7-bbca-2ea2e7b0ac76",
                        content: "Nibh mauris cursus mattis molestie. Varius vel pharetra vel turpis nunc eget lorem dolor.",
                    },
                    {
                        id: "b9dad22b-d7b9-4ca2-9585-c8762a15de9c",
                        content: "Turpis egestas maecenas pharetra convallis posuere morbi leo urna molestie.",
                    },
                    {
                        id: "b87bd7d4-03b1-4107-accc-de86415f1de0",
                        content: "Enim blandit volutpat maecenas volutpat blandit aliquam etiam erat.",
                    },
                    {
                        id: "6c8c8717-7069-4f37-865a-e69c8c01a6ba",
                        content: "Fermentum dui faucibus in ornare. In hac habitasse platea dictumst vestibulum rhoncus est pellentesque elit.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-latest-media",
        name: "Latest Media",
        articles: [
            {
                id: "b419e5f0-1707-4c0e-85b3-48f26a70f91b",
                class: "columns-1",
                type: "grid",
                content: [
                    {
                        id: "a2ef309b-d8af-4621-9a33-883269394a96",
                        image: {
                            src: "assets/images/steven-van-bTPP3jBnOb8-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "fb3262b1-6618-4d3d-998b-6072104beefa",
                        image: {
                            src: "assets/images/markus-spiske-WUehAgqO5hE-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "ed0edcac-b8f1-43d4-a0a3-fdee2812122e",
                        image: {
                            src: "assets/images/david-everett-strickler-igCBFrMd11I-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                    {
                        id: "0b55ff73-13ca-43ae-9980-d02d01abd921",
                        image: {
                            src: "assets/images/marco-oriolesi-wqLGlhjr6Og-unsplash_684.jpg",
                            alt: "Placeholder",
                            width: "684",
                            height: "385",
                        },
                        meta: {
                            tag: {
                                type: "watch",
                                label: "watch",
                            },
                        },
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-highlights",
        name: "Highlights",
        articles: [
            {
                id: "1519cdfe-bb32-4f0a-aad1-2f4bb87096a4",
                class: "columns-wrap",
                header: "Domestic Highlights",
                type: "excerpt",
                content: [
                    {
                        id: "ff2abe6a-3418-473e-80c1-b262188e5554",
                        image: {
                            src: "assets/images/samuel-schroth-hyPt63Df3Dw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "At urna condimentum mattis pellentesque id nibh tortor id. Urna cursus eget nunc scelerisque viverra mauris in. Pretium vulputate sapien nec sagittis aliquam malesuada bibendum arcu.",
                    },
                    {
                        id: "7ea12782-cf94-459d-b7ec-3be5d43175cf",
                        image: {
                            src: "assets/images/denys-nevozhai-7nrsVjvALnA-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Enim lobortis scelerisque fermentum dui faucibus in. Vitae semper quis lectus nulla at volutpat. In nisl nisi scelerisque eu ultrices vitae auctor.",
                    },
                    {
                        id: "0af1cd6a-a044-43b4-8ec8-26b71a0a9ca4",
                        image: {
                            src: "assets/images/mattia-bericchia-xkD79yf4tb8-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Lorem donec massa sapien faucibus et molestie ac feugiat. Quis varius quam quisque id diam vel. Ut tristique et egestas quis ipsum suspendisse. Fermentum posuere urna nec tincidunt praesent semper feugiat.",
                    },
                ],
            },
            {
                id: "0b9b6f8c-0dde-4c2f-82dd-b777fa84881d",
                class: "columns-wrap",
                header: "Global Highlights",
                type: "excerpt",
                content: [
                    {
                        id: "c69ff80d-44cf-463a-b3db-bc2f22e8993c",
                        image: {
                            src: "assets/images/maximilian-bungart-nwqfl_HtJjk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Augue eget arcu dictum varius duis at consectetur. Ornare arcu dui vivamus arcu felis bibendum ut. Magna eget est lorem ipsum dolor sit amet. Tincidunt nunc pulvinar sapien et ligula ullamcorper malesuada proin.",
                    },
                    {
                        id: "24cfa9e5-9a6c-4e00-980a-05a5d583e718",
                        image: {
                            src: "assets/images/gaku-suyama-VyiLZUcdJv0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Leo urna molestie at elementum eu facilisis sed. Est lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque.",
                    },
                    {
                        id: "3bf00e72-8821-446d-8096-1d5d3ea5c8c9",
                        image: {
                            src: "assets/images/paul-bill-HLuPjCa6IYw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Nisi scelerisque eu ultrices vitae auctor. Quis risus sed vulputate odio. Pellentesque sit amet porttitor eget dolor morbi non. Nullam eget felis eget nunc lobortis mattis aliquam.",
                    },
                ],
            },
            {
                id: "8eed7659-370e-4a45-8977-b21eb88ab793",
                class: "columns-wrap",
                header: "Local Highlights",
                type: "excerpt",
                content: [
                    {
                        id: "72522d42-30bf-42f0-ba21-5dbc080dfab1",
                        image: {
                            src: "assets/images/maarten-van-den-heuvel-gZXx8lKAb7Y-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Mattis ullamcorper velit sed ullamcorper. Orci ac auctor augue mauris augue neque. Condimentum mattis pellentesque id nibh tortor.",
                    },
                    {
                        id: "bab8b49c-4e37-4cf8-8c52-714cb53daf5d",
                        image: {
                            src: "assets/images/quino-al-KydWCDJe9s0-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Fermentum odio eu feugiat pretium. Urna nec tincidunt praesent semper feugiat nibh sed. Adipiscing elit ut aliquam purus sit.",
                    },
                    {
                        id: "eb3516e6-ad00-4d39-822c-acc4eab9befa",
                        image: {
                            src: "assets/images/mathurin-napoly-matnapo-pIJ34ZrZEEw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Vitae tempus quam pellentesque nec nam aliquam sem et. Fringilla urna porttitor rhoncus dolor purus non enim praesent elementum. Congue nisi vitae suscipit tellus mauris a diam maecenas. Quis varius quam quisque id diam.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-top-stories",
        name: "Top Stories",
        articles: [
            {
                id: "4e01d65b-b4f0-4b43-8d28-2fb8f918071c",
                class: "columns-1",
                type: "grid",
                display: "grid-wrap",
                content: [
                    {
                        id: "2923bc4a-fceb-45e7-bf92-f9e8f9d826ec",
                        image: {
                            src: "assets/images/andrew-solok-LbckXdUVOlY-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Ut venenatis tellus in metus vulputate eu scelerisque. In nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. Mattis nunc sed blandit libero volutpat sed cras ornare arcu. Scelerisque eu ultrices vitae auctor eu augue. Libero justo laoreet sit amet cursus sit amet.",
                        url: "#",
                    },
                    {
                        id: "9268157a-12cb-442f-9401-0d88d1846662",
                        image: {
                            src: "assets/images/hassan-kibwana-fmXLB_uHIh4-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Non consectetur a erat nam. Blandit massa enim nec dui nunc mattis enim ut. Tempor orci eu lobortis elementum nibh tellus molestie nunc. Facilisi etiam dignissim diam quis enim lobortis scelerisque fermentum dui.",
                        url: "#",
                    },
                    {
                        id: "5113935d-4ed6-4897-a49a-d730de47a973",
                        image: {
                            src: "assets/images/craig-manners-LvJCFOW3Ma8-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Eget est lorem ipsum dolor sit amet. Vivamus at augue eget arcu dictum varius duis at consectetur. Scelerisque fermentum dui faucibus in ornare quam viverra orci sagittis. Vitae sapien pellentesque habitant morbi tristique senectus et.",
                        url: "#",
                    },
                    {
                        id: "8dbd8d34-edb4-4583-9468-0009d55745c9",
                        image: {
                            src: "assets/images/albert-stoynov-fEdf0fig3os-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Diam in arcu cursus euismod quis viverra nibh cras pulvinar. Est velit egestas dui id ornare arcu odio ut sem. A cras semper auctor neque. Ipsum suspendisse ultrices gravida dictum fusce ut.",
                        url: "#",
                    },
                    {
                        id: "ec4d93f4-83f7-4427-81fc-b6420d590718",
                        image: {
                            src: "assets/images/ehimetalor-akhere-unuabona-yS0uBoF4xDo-unsplash_448.jpg",
                            alt: "Placeholder",
                            width: "448",
                            height: "252",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Tellus integer feugiat scelerisque varius morbi enim. Diam donec adipiscing tristique risus nec feugiat in fermentum. Volutpat odio facilisis mauris sit amet massa vitae. Tempor orci dapibus ultrices in iaculis nunc sed. Aenean vel elit scelerisque mauris pellentesque pulvinar.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-international",
        name: "International",
        articles: [
            {
                id: "c5deda28-5da7-4641-80dd-e9859088c95d",
                class: "columns-3-balanced",
                header: "Europe",
                type: "articles-list",
                content: [
                    {
                        id: "6a93436c-6c5b-44a7-938e-ebb1f2ee3c15",
                        title: "Commodo elit at imperdiet dui accumsan sit amet. Habitasse platea dictumst vestibulum rhoncus.",
                        content:
                            "Orci ac auctor augue mauris augue neque gravida. Lectus magna fringilla urna porttitor rhoncus dolor purus non enim. Sagittis aliquam malesuada bibendum arcu vitae. Pellentesque habitant morbi tristique senectus et netus. Etiam erat velit scelerisque in dictum non consectetur a.",
                    },
                    {
                        id: "283ea033-d01a-48a9-b584-635b0b3c8c30",
                        title: "Suspendisse convallis efficitur felis ac mattis. Cras faucibus ultrices condimentum.",
                        content:
                            "Facilisis leo vel fringilla est. Turpis tincidunt id aliquet risus feugiat in ante metus. Viverra ipsum nunc aliquet bibendum enim facilisis. Tristique et egestas quis ipsum suspendisse ultrices gravida dictum. Tristique senectus et netus et malesuada fames ac turpis egestas.",
                    },
                    {
                        id: "5670b9e0-4b99-48d5-8b31-525ae350de32",
                        title: "Ornare suspendisse sed nisi lacus sed viverra tellus in.",
                        content: "Dui vivamus arcu felis bibendum. Purus ut faucibus pulvinar elementum integer enim neque volutpat ac. Auctor eu augue ut lectus arcu bibendum. Diam volutpat commodo sed egestas egestas fringilla phasellus.",
                    },
                ],
            },
            {
                id: "387033b0-e832-48b3-a3fe-f104075cf93a",
                class: "columns-3-balanced",
                header: "South America",
                type: "articles-list",
                content: [
                    {
                        id: "ace185f1-1e8a-4db5-9266-95412f7b06ff",
                        title: "Augue eget arcu dictum varius duis.",
                        content: "Commodo ullamcorper a lacus vestibulum sed arcu non. Nullam ac tortor vitae purus faucibus ornare suspendisse sed. Id interdum velit laoreet id donec ultrices tincidunt arcu non.",
                    },
                    {
                        id: "3a4170ea-bd6f-4de9-94e9-7f487d68e1eb",
                        title: "Fringilla ut morbi tincidunt augue interdum velit euismod in pellentesque.",
                        content:
                            "Turpis egestas maecenas pharetra convallis posuere morbi leo. Odio pellentesque diam volutpat commodo. Ornare massa eget egestas purus viverra accumsan in nisl nisi. Tellus integer feugiat scelerisque varius morbi enim nunc. Erat velit scelerisque in dictum non consectetur.",
                    },
                    {
                        id: "b5b51051-9b1c-496b-8390-432802b4e1e7",
                        title: "Mi bibendum neque egestas congue quisque.",
                        content: "Sapien eget mi proin sed libero. Adipiscing elit duis tristique sollicitudin nibh sit. Faucibus scelerisque eleifend donec pretium. Ac tortor dignissim convallis aenean et tortor at risus.",
                    },
                ],
            },
            {
                id: "06fa8c40-6678-483b-bbb5-a8f73822d1e1",
                class: "columns-3-balanced",
                header: "Asia",
                type: "articles-list",
                content: [
                    {
                        id: "3654e18a-e633-4774-899a-7517b2ff28c7",
                        title: "Sodales ut etiam sit amet nisl purus in. Enim sed faucibus turpis in eu mi bibendum neque.",
                        content: "Tortor id aliquet lectus proin. Pulvinar elementum integer enim neque volutpat ac tincidunt. Auctor eu augue ut lectus arcu bibendum at varius. Congue mauris rhoncus aenean vel elit scelerisque mauris.",
                    },
                    {
                        id: "3461de32-20f7-4787-b31c-4c1b08b9e02b",
                        title: "haretra convallis posuere morbi leo urna.",
                        content:
                            "Egestas diam in arcu cursus euismod quis. Ac turpis egestas integer eget aliquet nibh praesent tristique magna. Molestie at elementum eu facilisis sed odio morbi quis. Lectus arcu bibendum at varius. Eros in cursus turpis massa tincidunt dui.",
                    },
                    {
                        id: "3fe9e8db-160b-4a2d-b586-33cce8f4c3fa",
                        title: "At varius vel pharetra vel turpis nunc eget lorem dolor. ",
                        content: "Proin sagittis nisl rhoncus mattis rhoncus urna neque viverra. Lacus sed viverra tellus in. Sed nisi lacus sed viverra tellus in. Venenatis cras sed felis eget velit aliquet sagittis id consectetur.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-featured",
        name: "Featured",
        articles: [
            {
                id: "f0704a5e-cf35-4c2b-afc1-c07325577554",
                class: "columns-3-balanced",
                header: "Washington",
                image: {
                    src: "assets/images/heidi-kaden-L_U4jhwZ6hY-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Et netus et malesuada fames ac.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "e82d88ff-6406-4f82-8d8a-3c0939cda3ba",
                        content: "Vulputate dignissim suspendisse in est ante.",
                        url: "#",
                    },
                    {
                        id: "0dc64ba7-dc5b-4cb4-b729-fbee531ae382",
                        content: "Blandit turpis cursus in hac habitasse platea dictumst.",
                        url: "#",
                    },
                    {
                        id: "8a54f7e2-3aec-4e91-a029-9b9fe2a9bf07",
                        content: "Sed nisi lacus sed viverra tellus in hac.",
                        url: "#",
                    },
                    {
                        id: "337cf7d7-0cbf-4a6f-ba8d-f5ab56f542af",
                        content: "Euismod in pellentesque massa placerat duis ultricies lacus sed.",
                        url: "#",
                    },
                    {
                        id: "b93dfad8-0ad4-4825-bdf2-b9a6c77ed21a",
                        content: "Quam lacus suspendisse faucibus interdum posuere.",
                        url: "#",
                    },
                    {
                        id: "28b3b72d-55c5-4f42-b51b-c6c5fffc506d",
                        content: "Sit amet mattis vulputate enim nulla aliquet porttitor lacus.",
                        url: "#",
                    },
                ],
            },
            {
                id: "9f57970b-05f9-45c2-9e3c-ab0f66ce47f3",
                class: "columns-3-balanced",
                header: "New York",
                image: {
                    src: "assets/images/hannah-busing-0V6DmTuJaIk-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Commodo quis imperdiet massa tincidunt nunc pulvinar sapien et ligula.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "36576fce-6f70-4b2f-b635-d586a51b3a9b",
                        content: "Id semper risus in hendrerit gravida rutrum quisque non.",
                        url: "#",
                    },
                    {
                        id: "efd66d67-6a81-46be-b682-6dfa7b5895df",
                        content: "Sit amet est placerat in egestas erat imperdiet sed euismod.",
                        url: "#",
                    },
                    {
                        id: "1390fee3-5d9b-468c-8d95-9c04943a3561",
                        content: "Aliquam malesuada bibendum arcu vitae elementum curabitur vitae nunc.",
                        url: "#",
                    },
                    {
                        id: "a2f63129-54de-4003-8070-42dbba2c1bfd",
                        content: "get gravida cum sociis natoque. Bibendum ut tristique et egestas.",
                        url: "#",
                    },
                    {
                        id: "9eec6eb8-c67e-4b57-8e7e-fe4a71dbae2b",
                        content: "Mauris cursus mattis molestie a iaculis at erat.",
                        url: "#",
                    },
                    {
                        id: "677e1086-aef8-4561-8ecb-af75a7c82f6f",
                        content: "Sit amet massa vitae tortor condimentum lacinia.",
                        url: "#",
                    },
                ],
            },
            {
                id: "bda30bf1-8032-4bfa-b17d-07571a7251f7",
                class: "columns-3-balanced",
                header: "Los Angeles",
                image: {
                    src: "assets/images/martin-jernberg-jVNWCFwdjZU-unsplash_448.jpg",
                    alt: "Placeholder",
                    width: "448",
                    height: "252",
                },
                meta: {
                    captions: "Photo taken by someone.",
                },
                title: "Parturient montes nascetur ridiculus mus mauris.",
                type: "list",
                display: "bullets",
                content: [
                    {
                        id: "51427dca-f312-4cc7-b7b2-719bf4c5cd8a",
                        content: "Mattis enim ut tellus elementum sagittis.",
                        url: "#",
                    },
                    {
                        id: "6f3ae21d-312b-4065-8af1-04719f6d3160",
                        content: "Sit amet venenatis urna cursus eget nunc scelerisque viverra mauris.",
                        url: "#",
                    },
                    {
                        id: "352dec10-0863-4244-a60b-002e40022c94",
                        content: "Mi bibendum neque egestas congue quisque egestas.",
                        url: "#",
                    },
                    {
                        id: "e31c2cc9-5f99-4a01-84cf-587dcf47be7e",
                        content: "Nunc scelerisque viverra mauris in aliquam.",
                        url: "#",
                    },
                    {
                        id: "9c041d54-ea0b-4a63-877b-a793f1b84297",
                        content: "Egestas erat imperdiet sed euismod nisi porta lorem mollis aliquam.",
                        url: "#",
                    },
                    {
                        id: "a31a24a9-708a-4227-9038-bd14a0a7c7b1",
                        content: "Phasellus egestas tellus rutrum tellus pellentesque eu tincidunt tortor aliquam.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-underscored",
        name: "Underscored",
        articles: [
            {
                id: "affd2923-97de-4410-9258-bce3e4a19b87",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "92946ccb-022d-4319-be94-49e476c31077",
                        image: {
                            src: "assets/images/kevin-wang-t7vEVxwGGm0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Rhoncus urna neque viverra justo nec. Dis parturient montes nascetur ridiculus mus mauris vitae ultricies leo. Praesent semper feugiat nibh sed pulvinar proin gravida hendrerit lectus. Enim nunc faucibus a pellentesque sit amet. Est ullamcorper eget nulla facilisi.",
                        url: "#",
                    },
                    {
                        id: "419ea32d-d12e-4c2b-9a14-fee91ba7ee7f",
                        image: {
                            src: "assets/images/claudio-schwarz-3cWxxW2ggKE-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Enim lobortis scelerisque fermentum dui faucibus in ornare quam. Iaculis urna id volutpat lacus laoreet non curabitur gravida. Non quam lacus suspendisse faucibus. Elit ullamcorper dignissim cras tincidunt lobortis feugiat vivamus at. Bibendum est ultricies integer quis auctor elit.",
                        url: "#",
                    },
                ],
            },
            {
                id: "a196957d-d9fa-400a-a94c-dca3f6815700",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "4e31cef9-8787-437c-ae06-9e5654f540d9",
                        image: {
                            src: "assets/images/braden-collum-9HI8UJMSdZA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Faucibus scelerisque eleifend donec pretium vulputate. Lacus luctus accumsan tortor posuere. Nulla facilisi nullam vehicula ipsum a arcu cursus vitae. Viverra aliquet eget sit amet tellus cras adipiscing. Congue quisque egestas diam in arcu cursus.",
                        url: "#",
                    },
                    {
                        id: "292cc517-c2d8-4941-acf3-bfe9a33cea58",
                        image: {
                            src: "assets/images/geoff-scott-8lUTnkZXZSA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Cum sociis natoque penatibus et magnis dis parturient montes. Ut eu sem integer vitae justo eget magna fermentum iaculis. Amet venenatis urna cursus eget nunc scelerisque viverra. Quisque id diam vel quam elementum. Nulla facilisi cras fermentum odio eu feugiat pretium nibh.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-happening-now",
        name: "Happening Now",
        articles: [
            {
                id: "f07e6f59-5962-4410-b1a1-493770fa85c6",
                class: "columns-wrap",
                header: "Political",
                type: "excerpt",
                content: [
                    {
                        id: "501331da-4f36-4a63-8e37-78fbc84d7485",
                        image: {
                            src: "assets/images/jonathan-simcoe-S9J1HqoL9ns-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Cras semper auctor neque vitae tempus quam pellentesque. Consequat ac felis donec et odio pellentesque. Eu consequat ac felis donec et odio pellentesque diam volutpat. Suscipit tellus mauris a diam maecenas sed enim ut sem.",
                    },
                    {
                        id: "72c9a293-beba-4604-8a5b-ae6ec5dbdcf0",
                        image: {
                            src: "assets/images/markus-spiske-p2Xor4Lbrrk-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Sed faucibus turpis in eu mi bibendum neque. Condimentum id venenatis a condimentum vitae sapien pellentesque habitant morbi. In iaculis nunc sed augue lacus viverra. Pellentesque nec nam aliquam sem et. Tellus mauris a diam maecenas sed.",
                    },
                    {
                        id: "505495bc-4141-4277-aba5-08cecdb0f52c",
                        image: {
                            src: "assets/images/marius-oprea-ySA9uj7zSmw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Mattis vulputate enim nulla aliquet. Ac tortor dignissim convallis aenean. Nulla posuere sollicitudin aliquam ultrices sagittis orci a scelerisque. Consequat ac felis donec et odio pellentesque diam. Lorem ipsum dolor sit amet consectetur adipiscing.",
                    },
                ],
            },
            {
                id: "3c3b206d-1b03-4fcc-9469-25b2caa64622",
                class: "columns-wrap",
                header: "Health",
                type: "excerpt",
                content: [
                    {
                        id: "ce276359-8308-4af0-8d6f-c9141503f972",
                        image: {
                            src: "assets/images/jannis-brandt-mmsQUgMLqUo-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Vitae tortor condimentum lacinia quis. Nisl nisi scelerisque eu ultrices vitae. Id velit ut tortor pretium viverra suspendisse potenti nullam. Viverra accumsan in nisl nisi scelerisque eu ultrices vitae.",
                    },
                    {
                        id: "e3a10fed-2a09-4821-aad0-b8af9f906769",
                        image: {
                            src: "assets/images/martha-dominguez-de-gouveia-k-NnVZ-z26w-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Ullamcorper malesuada proin libero nunc consequat. Imperdiet sed euismod nisi porta. Arcu cursus vitae congue mauris rhoncus aenean vel. Enim nunc faucibus a pellentesque. Gravida in fermentum et sollicitudin ac orci phasellus.",
                    },
                    {
                        id: "3676e79b-88d4-454c-ae72-32e3f38b869f",
                        image: {
                            src: "assets/images/freestocks-nss2eRzQwgw-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Morbi tristique senectus et netus et malesuada fames. Sit amet cursus sit amet dictum sit. Sagittis vitae et leo duis ut diam quam. Non consectetur a erat nam at lectus. Massa massa ultricies mi quis hendrerit dolor magna eget est.",
                    },
                ],
            },
            {
                id: "19a7a320-69b7-4ac6-b2b1-17206ccc8e67",
                class: "columns-wrap",
                header: "Business",
                type: "excerpt",
                content: [
                    {
                        id: "8431d24b-4967-4434-b165-18af09cbfe81",
                        image: {
                            src: "assets/images/little-plant-TZw891-oMio-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Integer enim neque volutpat ac. Feugiat sed lectus vestibulum mattis. Ullamcorper malesuada proin libero nunc consequat interdum varius sit amet. Mattis molestie a iaculis at erat pellentesque. Adipiscing elit duis tristique sollicitudin.",
                    },
                    {
                        id: "50fa2776-bff8-42c7-a0ea-883cf40e66cf",
                        image: {
                            src: "assets/images/allan-wadsworth-Lp78NT-mf9o-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Dignissim sodales ut eu sem integer. Mauris cursus mattis molestie a iaculis at erat. Tempus quam pellentesque nec nam aliquam sem et tortor. Id diam vel quam elementum pulvinar etiam non quam.",
                    },
                    {
                        id: "f9099723-cd63-4158-906e-d9bf33904156",
                        image: {
                            src: "assets/images/ant-rozetsky-SLIFI67jv5k-unsplash_150.jpg",
                            alt: "Placeholder",
                            width: "150",
                            height: "84",
                        },
                        text: "Massa vitae tortor condimentum lacinia quis vel eros. Platea dictumst vestibulum rhoncus est pellentesque. Sollicitudin tempor id eu nisl nunc mi ipsum faucibus vitae. Sed risus ultricies tristique nulla aliquet. Magna sit amet purus gravida quis blandit turpis cursus in.",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-hot-topics",
        name: "Hot Topics",
        articles: [
            {
                id: "514e6188-22a4-4d01-ac19-342df74680e7",
                class: "columns-2-balanced",
                header: "This First",
                type: "grid",
                content: [
                    {
                        id: "79d06fe0-30a7-41b8-b318-1aca53454296",
                        image: {
                            src: "assets/images/alexandre-debieve-FO7JIlwjOtU-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Amet nisl suscipit adipiscing bibendum. Elit ullamcorper dignissim cras tincidunt lobortis feugiat. Non odio euismod lacinia at. Risus viverra adipiscing at in tellus integer feugiat scelerisque.",
                        url: "#",
                    },
                    {
                        id: "6c9f3533-ab33-4099-a38c-f2841d7ca278",
                        image: {
                            src: "assets/images/thisisengineering-ZPeXrWxOjRQ-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "new",
                                label: "new",
                            },
                        },
                        text: "Viverra suspendisse potenti nullam ac tortor. Tellus id interdum velit laoreet id donec. Dui nunc mattis enim ut tellus. Nec ullamcorper sit amet risus nullam eget felis eget. Viverra suspendisse potenti nullam ac tortor vitae purus faucibus.",
                        url: "#",
                    },
                ],
            },
            {
                id: "df35d241-7b4e-41af-b4a8-aa5ac86a2625",
                class: "columns-2-balanced",
                header: "This Second",
                type: "grid",
                content: [
                    {
                        id: "16d97cdf-e13a-4470-8d7b-70ef8a0d6542",
                        image: {
                            src: "assets/images/isaw-company-Oqv_bQbZgS8-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Commodo ullamcorper a lacus vestibulum sed arcu non odio euismod. Etiam non quam lacus suspendisse. Hac habitasse platea dictumst vestibulum rhoncus est.",
                        url: "#",
                    },
                    {
                        id: "26c3b788-742a-4b7a-824e-91db371e5083",
                        image: {
                            src: "assets/images/aditya-chinchure-ZhQCZjr9fHo-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "breaking",
                            },
                        },
                        text: "Mi eget mauris pharetra et ultrices neque ornare aenean euismod. Egestas congue quisque egestas diam in arcu cursus euismod quis. Tincidunt id aliquet risus feugiat. Viverra nibh cras pulvinar mattis nunc sed.",
                        url: "#",
                    },
                ],
            },
        ],
    },
    {
        id: "content-frontpage-paid-content",
        name: "Paid Content",
        articles: [
            {
                id: "694bbfce-f1c9-4e10-95bc-a89023d5e1ea",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "39a82f01-b2fc-4740-a5ca-f1ada041100a",
                        image: {
                            src: "assets/images/tamara-bellis-IwVRO3TLjLc-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Nunc aliquet bibendum enim facilisis gravida neque. Nec feugiat in fermentum posuere urna. Molestie at elementum eu facilisis sed odio morbi. Scelerisque purus semper eget duis at tellus.",
                    },
                    {
                        id: "8a50960e-fbde-4705-bc6a-76865f78ec50",
                        image: {
                            src: "assets/images/david-lezcano-NfZiOJzZgcg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Eget dolor morbi non arcu risus quis. Non curabitur gravida arcu ac tortor dignissim.",
                    },
                ],
            },
            {
                id: "6e110ab5-5d43-411b-a64e-3dae38960a60",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "9728082f-7e27-4366-8bf4-dbd74f13daf8",
                        image: {
                            src: "assets/images/heidi-fin-2TLREZi7BUg-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Quam lacus suspendisse faucibus interdum. In pellentesque massa placerat duis ultricies lacus sed. Convallis a cras semper auctor neque vitae tempus quam. Ut pharetra sit amet aliquam id diam.",
                    },
                    {
                        id: "216eaa21-8a0f-4baf-8dc3-103391d77002",
                        image: {
                            src: "assets/images/joshua-rawson-harris-YNaSz-E7Qss-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Vel fringilla est ullamcorper eget nulla facilisi etiam dignissim diam. Eu feugiat pretium nibh ipsum consequat.",
                    },
                ],
            },
            {
                id: "e72adfa5-f82e-42b3-a0c6-c43f0c3f9393",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "848a8767-90da-4ff1-a2b1-293def11434f",
                        image: {
                            src: "assets/images/arturo-rey-5yP83RhaFGA-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Non tellus orci ac auctor augue mauris augue neque gravida. Nulla facilisi nullam vehicula ipsum a arcu cursus vitae. Quam nulla porttitor massa id neque aliquam vestibulum morbi. Diam quis enim lobortis scelerisque.",
                    },
                    {
                        id: "f9c3995e-c12d-47ef-89e6-efb535d7678a",
                        image: {
                            src: "assets/images/clem-onojeghuo-RLJnH4Mt9A0-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Haretra diam sit amet nisl suscipit adipiscing bibendum est ultricies. Senectus et netus et malesuada fames.",
                    },
                ],
            },
            {
                id: "96bc6b53-c533-4970-adb7-8dae30da76cc",
                class: "columns-4-balanced",
                type: "preview",
                content: [
                    {
                        id: "15d8615d-52c0-4aa5-a0d0-2eb20c6c0675",
                        image: {
                            src: "assets/images/ashim-d-silva-ZmgJiztRHXE-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "It amet porttitor eget dolor morbi non. Sed lectus vestibulum mattis ullamcorper. Laoreet id donec ultrices tincidunt arcu non. Quam adipiscing vitae proin sagittis.",
                    },
                    {
                        id: "75a08ef8-8177-4047-bb40-3448c0169cd9",
                        image: {
                            src: "assets/images/toa-heftiba--abWByT3yg4-unsplash_336.jpg",
                            alt: "Placeholder",
                            width: "336",
                            height: "189",
                        },
                        title: "Mollis aliquam ut porttitor leo a diam. Nunc aliquet bibendum enim facilisis gravida neque convallis.",
                    },
                ],
            },
        ],
    },
];
